import { useOptimizationGroupsQuery } from '@/entities/optimization-group'
import { useGlobalPcSetsQuery } from '@/entities/pricing-campaign'

import { transformToOptions } from './transformToOptions'

export const useModalOptions = () => {
	const {
		data: optimizationGroupsOptions,
		isLoading: isOptimizationGroupsLoading,
	} = useOptimizationGroupsQuery({
		select: transformToOptions,
	})

	const { data: globalSetsOptions, isLoading: isGlobalSetsLoading } =
		useGlobalPcSetsQuery({
			select: transformToOptions,
		})

	return {
		optimizationGroupsOptions: optimizationGroupsOptions || [],
		globalSetsOptions: globalSetsOptions || [],
		isLoading: isGlobalSetsLoading || isOptimizationGroupsLoading,
	}
}
